import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext, useCallback, useState, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import ClearableInput, { hasPrefixSuffix } from './ClearableLabeledInput';
import devWarning from '../_utils/devwarning';
import { useMergedState } from '../_utils/hooks';
export var InputSiteTypes = tuple('large', 'middle', 'small');
export var BorderTypes = tuple('none', 'underline', 'bordered');
export function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return value;
}

var InternalInput = function InternalInput(props, ref) {
  var _context, _classNames;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var inputProps = getCompProps('Input', userDefaultProps, props);

  var type = inputProps.type,
      size = inputProps.size,
      disabled = inputProps.disabled,
      onPressEnter = inputProps.onPressEnter,
      borderType = inputProps.borderType,
      customPrefixcls = inputProps.prefixCls,
      onFocus = inputProps.onFocus,
      onBlur = inputProps.onBlur,
      onChange = inputProps.onChange,
      placeholderTobeValue = inputProps.placeholderTobeValue,
      defaultValue = inputProps.defaultValue,
      propsValue = inputProps.value,
      className = inputProps.className,
      others = __rest(inputProps, ["type", "size", "disabled", "onPressEnter", "borderType", "prefixCls", "onFocus", "onBlur", "onChange", "placeholderTobeValue", "defaultValue", "value", "className"]);

  devWarning(InputSiteTypes.indexOf(size) === -1, 'input', "cannot found input size '".concat(size, "'"));
  devWarning(BorderTypes.indexOf(borderType) === -1, 'input', "cannot found input borderType '".concat(borderType, "'"));

  var _useMergedState = useMergedState('', {
    value: propsValue,
    defaultValue: defaultValue
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var thisInputRef = useRef();
  var inputRef = ref || thisInputRef;
  var inputPrefixCls = getPrefixCls(prefixCls, 'input', customPrefixcls); // 按钮样式前缀

  var addonBefore = others.addonBefore,
      addonAfter = others.addonAfter;
  var inputClasses = classNames(inputPrefixCls, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(inputPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames, "".concat(inputPrefixCls, "-borderless"), borderType === 'none'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames), _defineProperty({}, className, className && !hasPrefixSuffix(inputProps) && !addonBefore && !addonAfter));
  var handleFocus = useCallback(function (event) {
    setFocused(true);
    onFocus && onFocus(event);
  }, [onFocus]);
  var handleBlur = useCallback(function (event) {
    setFocused(false);
    onBlur && onBlur(event);
  }, [onBlur]);
  var handleChange = useCallback(function (event) {
    propsValue === undefined && setValue(event.target.value);
    onChange && onChange(event);
  }, [onChange]);

  var handleReset = function handleReset() {
    setValue('');
    var event = {
      target: {
        value: ''
      }
    };

    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus();
      event.target = inputRef.current;
    }

    onChange && onChange(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (onPressEnter && event.key === 'Enter') {
      var newValue = placeholderTobeValue && !value && !defaultValue ? inputProps.placeholder : value || defaultValue;
      onPressEnter && onPressEnter(newValue || '', event);
    }

    inputProps.onKeyUp && inputProps.onKeyUp(event);
  };

  var inputDomProps = _extends({}, others);

  delete inputDomProps.allowClear;
  delete inputDomProps.suffix;
  delete inputDomProps.addonAfter;
  delete inputDomProps.addonBefore;
  delete inputDomProps.className;

  var renderInput = function renderInput() {
    return /*#__PURE__*/React.createElement("input", _extends({
      ref: inputRef,
      type: type,
      disabled: disabled,
      className: inputClasses,
      value: fixControlledValue(value)
    }, inputDomProps, {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onKeyUp: handleKeyUp
    }));
  };

  return /*#__PURE__*/React.createElement(ClearableInput, _extends({}, inputProps, {
    handleReset: handleReset,
    value: value,
    inputType: "input",
    prefixCls: inputPrefixCls,
    element: renderInput(),
    focused: focused
  }));
};

var Input = /*#__PURE__*/React.forwardRef(InternalInput);
Input.displayName = 'Input';
export default Input;